export default __webpack_public_path__ + "static/media/house-plant.3c8a5d1b.svg";